import { languageToVoicesMap as _languageToVoicesMap } from '@/state/presenters';
import { IVoice } from '@d-id/types';
import { useRecoilValue } from 'recoil';

export const useGetLanguageByVoiceID = (id?: string) => {
    const languageToVoicesMap = useRecoilValue(_languageToVoicesMap);
    for (const language in languageToVoicesMap) {
        if (languageToVoicesMap[language].find((voice: IVoice) => voice.id === id)) {
            return language;
        }
    }
};
